import React, { useState } from 'react';
import { Row, Column } from 'react-foundation';

const DeleteTab = () => {
	const [active, setActive] = useState(false);

	const toggle = () => {
		setActive(!active);
	};

	return (
		<div>
			<button className="accordion card" onClick={toggle}>
				<div className="account-card-title">Delete account</div>
				<div className="account-card-text">We hate to see you go!</div>
				<div className="arrow-holder">
					<div className={active ? 'arrow active' : 'arrow'}></div>
				</div>
			</button>
			<div className={active ? 'dropdown active' : 'dropdown'}>
				<Row>
					<Column small={12}>
						<div className="header">
							Before you go, please keep in mind...
						</div>
						<ul className="bullet-points">
							<li className="bp">
								Deleting this account means erasing all your
								data, connections and settings
							</li>
							<li className="bp">
								Once it has been deleted, it is not possible to
								recover your account
							</li>
						</ul>
					</Column>
				</Row>
				<Row>
					<Column small={12}>
						<div className="button-holder">
							<form
								className="button_to"
								method="post"
								action="/users"
							>
								<input
									dataconfirm="Are you sure?"
									type="submit"
									value="Delete"
									className="primary-button long"
								></input>
							</form>
						</div>
					</Column>
				</Row>
			</div>
		</div>
	);
};

export default DeleteTab;
